// used for exponential smoothing in charts
export const NdviDataSmoothingFactor = 0.3;

export const NDVIPalette = [
  { offset: 1.0, color: '#003200' },
  { offset: 0.9, color: '#15542d' },
  // { offset: 0.85, color: '#24602d' },
  { offset: 0.8, color: '#2c7000' },
  // { offset: 0.75, color: '#458100' },
  { offset: 0.7, color: '#5a8e03' },
  // { offset: 0.65, color: '#72a000' },
  { offset: 0.6, color: '#89af01' },
  // { offset: 0.55, color: '#a2c000' },
  { offset: 0.5, color: '#b9cf04' },
  // { offset: 0.45, color: '#d0df01' },
  { offset: 0.4, color: '#e6ec07' },
  // { offset: 0.35, color: '#fdfe01' },
  { offset: 0.3, color: '#cda917' },
  { offset: 0.2, color: '#9f512a' },
  { offset: 0.05, color: '#422112' },
  { offset: 0, color: '#422112' },
];

export const NDVIPaletteFull = [
  { offset: 1.0, color: '#003200' },
  { offset: 0.9, color: '#15542d' },
  { offset: 0.85, color: '#24602d' },
  { offset: 0.8, color: '#2c7000' },
  { offset: 0.75, color: '#458100' },
  { offset: 0.7, color: '#5a8e03' },
  { offset: 0.65, color: '#72a000' },
  { offset: 0.6, color: '#89af01' },
  { offset: 0.55, color: '#a2c000' },
  { offset: 0.5, color: '#b9cf04' },
  { offset: 0.45, color: '#d0df01' },
  { offset: 0.4, color: '#e6ec07' },
  { offset: 0.35, color: '#fdfe01' },
  { offset: 0.3, color: '#cda917' },
  { offset: 0.2, color: '#9f512a' },
  { offset: 0.05, color: '#422112' },
  { offset: 0, color: '#422112' },
];

export const NDVIPaletteHEX = [
  { offset: -1, color: 0x422112 },
  { offset: 0, color: 0x422112 },
  { offset: 0.05, color: 0x422112 },
  { offset: 0.2, color: 0x9f512a },
  { offset: 0.3, color: 0xcda917 },
  { offset: 0.35, color: 0xfdfe01 },
  { offset: 0.4, color: 0xe6ec07 },
  { offset: 0.45, color: 0xd0df01 },
  { offset: 0.5, color: 0xb9cf04 },
  { offset: 0.55, color: 0xa2c000 },
  { offset: 0.6, color: 0x89af01 },
  { offset: 0.65, color: 0x72a000 },
  { offset: 0.7, color: 0x5a8e03 },
  { offset: 0.75, color: 0x458100 },
  { offset: 0.8, color: 0x2c7000 },
  { offset: 0.85, color: 0x24602d },
  { offset: 0.9, color: 0x15542d },
  { offset: 1.0, color: 0x003200 },
];

export const NDVIPaletteRGB = [
  { offset: -1, color: [66, 33, 18] },
  { offset: 0, color: [66, 33, 18] },
  { offset: 0.05, color: [66, 33, 18] },
  { offset: 0.2, color: [159, 81, 42] },
  { offset: 0.3, color: [205, 169, 23] },
  { offset: 0.35, color: [253, 254, 1] },
  { offset: 0.4, color: [230, 236, 7] },
  { offset: 0.45, color: [208, 223, 1] },
  { offset: 0.5, color: [185, 207, 4] },
  { offset: 0.55, color: [162, 192, 0] },
  { offset: 0.6, color: [137, 175, 1] },
  { offset: 0.65, color: [114, 160, 0] },
  { offset: 0.7, color: [90, 142, 3] },
  { offset: 0.75, color: [69, 129, 0] },
  { offset: 0.8, color: [44, 112, 0] },
  { offset: 0.85, color: [36, 96, 45] },
  { offset: 0.9, color: [21, 84, 45] },
  { offset: 1.0, color: [0, 50, 0] },
];

export const DateFormat = 'YYYY-MM-DD';
export const DateLlFormat = 'MMM D, YYYY';
export const DateLLFormat = 'MMMM D, YYYY';
export const DateTimeFormat = 'MMMM D, YYYY h:mm A';
export const DateTimeLlFormat = 'MMM D, YYYY h:mm A';
export const DateTimeMDFormat = 'MMM D, h:mm A';
export const TimeFormat = 'h:mm A';

export const InitialEditLocationFields = {
  locationId: '',
  seasonId: '',
  name: '',
  install: '',
  removal: '',
  coordinates: [] as number[][],
};

export const TileMinZoom = 14;
export const LngDefault = 21.41524;
export const LatDefault = 53.5784;
